import * as Yup from "yup";
import { regexList } from "../../Constants";

export const loginIssueConstants = {
  labels: {
    issue: "Select one of the below mentioned issues:",
    goBack: (fromLogIn: boolean) =>
      `Back to ${fromLogIn ? "Log In" : "Registration"}`,
    phoneNumber: (fromLogIn: boolean) =>
      `Enter mobile number used for ${fromLogIn ? "Log In" : "Registration"}`
  },
  buttons: {
    submit: "Submit"
  },
  placeholders: {
    phoneNumber: "Enter Phone number"
  }
};

export enum IssueType {
  noOtpReceivedLogin = "OTP_NOT_RECEIVED",
  noOtpReceivedRegistration = "Mobile number is correct, but no OTP received. ",
  otpRejected = "OTP_NOT_ACCEPTED",
  others = "Others"
}

//converting to object for "radio button"
export const issueTypeOptions = (fromLogIn: boolean) => ({
  [fromLogIn
    ? IssueType.noOtpReceivedLogin.replace("OTP_NOT_RECEIVED","Mobile number and Email are correct, but no OTP received. ")
    : IssueType.noOtpReceivedRegistration]: fromLogIn
    ? IssueType.noOtpReceivedLogin
    : IssueType.noOtpReceivedRegistration,
  [IssueType.otpRejected.replace("OTP_NOT_ACCEPTED","OTP correctly entered, but not being accepted. ")]: IssueType.otpRejected,
  [IssueType.others]: IssueType.others
});

export const errorMessages = {
  captchaNotVerified: "Captcha not verified",
  required: "Required",
  invalidPhoneNumber: "Enter a valid Phone number"
};

export const loginIssueValidationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .matches(regexList.phoneNumber, errorMessages.invalidPhoneNumber)
    .required(errorMessages.required),
  issue: Yup.string().required(errorMessages.required),
  isVerified: Yup.boolean().oneOf([true], errorMessages.captchaNotVerified)
});
